import React from 'react';
import { ItemWrapper, StyledLink } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const Item = props => {
  const {
    name,
    url,
    isLast
  } = props;
  return /*#__PURE__*/_jsx(ItemWrapper, {
    children: /*#__PURE__*/_jsx(StyledLink, {
      isLast: isLast,
      name: name,
      href: url,
      children: name
    })
  });
};
//# sourceMappingURL=Item.js.map